import { Component, computed, input, signal } from '@angular/core';
import { Icon } from './icon';

@Component({
  selector: 'ipm-person-picture',
  imports: [Icon],
  template: `
    @if (source(); as url) {
      @if (failedUrl() !== url) {
        <img [src]="url" [alt]="name()" width="112" height="112" referrerpolicy="no-referrer" (error)="failedUrl.set(url)" />
      } @else {
        <span class="placeholder" role="img" [attr.aria-label]="name()"><ipm-icon name="contact" /></span>
      }
    } @else {
      <span class="placeholder" role="img" [attr.aria-label]="name()"><ipm-icon name="contact" /></span>
    }
  `,
  styles: `
    :host { display: block; width: 112px; height: 112px; max-width: 100%; margin-bottom: 20px; }
    img, .placeholder { display: flex; width: 100%; height: 100%; border-radius: 6px; object-fit: contain; background: var(--surface); }
    .placeholder { align-items: center; justify-content: center; color: var(--muted); border: 1px solid var(--line); }
  `,
})
export class PersonPicture {
  readonly imageUrl = input<unknown>(null);
  readonly name = input.required<string>();
  readonly failedUrl = signal<string | null>(null);
  readonly source = computed(() => {
    const value = this.imageUrl();
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value.trim());
      return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
    } catch {
      return null;
    }
  });
}